var VideoPoster = (function($) {
  function generatePoster(video) {
    if (!video) return;

    const hasPoster = video.getAttribute("poster");
    const posterTimeAttr = video.getAttribute("data-poster-time");

    if (hasPoster || !posterTimeAttr) {
      return;
    }

    const posterTime = parseFloat(posterTimeAttr);

    if (isNaN(posterTime)) {
      return;
    }

    const source = video.querySelector("source");
    const videoSrc = source
      ? source.getAttribute("data-src") || source.getAttribute("src")
      : "";

    if (!videoSrc) {
      return;
    }

    const tempVideo = document.createElement("video");
    tempVideo.muted = true;
    tempVideo.playsInline = true;
    tempVideo.preload = "auto";
    tempVideo.src = videoSrc;
    tempVideo.crossOrigin = "anonymous";

    const onLoadedData = function() {
      const duration = tempVideo.duration || 0;
      const safeTime =
        duration > 0
          ? Math.min(posterTime, Math.max(duration - 0.1, 0))
          : posterTime;

      tempVideo.currentTime = safeTime;
    };

    const onSeeked = function() {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = tempVideo.videoWidth;
        canvas.height = tempVideo.videoHeight;

        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        ctx.drawImage(tempVideo, 0, 0, canvas.width, canvas.height);

        const dataUrl = canvas.toDataURL("image/jpeg", 0.92);
        video.setAttribute("poster", dataUrl);
        video.load();
      } catch (error) {
        console.warn(
          "No se pudo generar el poster desde el frame del vídeo.",
          error
        );
      }

      cleanup();
    };

    const onError = function() {
      cleanup();
    };

    function cleanup() {
      tempVideo.removeEventListener("loadeddata", onLoadedData);
      tempVideo.removeEventListener("seeked", onSeeked);
      tempVideo.removeEventListener("error", onError);
      tempVideo.src = "";
    }

    tempVideo.addEventListener("loadeddata", onLoadedData);
    tempVideo.addEventListener("seeked", onSeeked);
    tempVideo.addEventListener("error", onError);
  }

  function init() {
    const videos = document.querySelectorAll(".js-work-item-video");

    if (!videos.length) {
      return;
    }

    videos.forEach(generatePoster);
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(function() {
  VideoPoster.init();
});
